/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Typ_KlasInputs */

const nl_planning_rooster_typ_klas = /** @type {(inputs: Planning_Rooster_Typ_KlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ een klas`)
};

/**

* @param {Planning_Rooster_Typ_KlasInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_typ_klas = /** @type {((inputs?: Planning_Rooster_Typ_KlasInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Typ_KlasInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_typ_klas(inputs)
});
export { planning_rooster_typ_klas as "planning.rooster.typ_klas" }